<template>
  <div class="animated-gift" data-t="animated-gift">
    <img v-if="isSafari" class="gif" src="./video/gift.gif" alt="gift" />
    <video v-else class="video" autoplay loop muted playsinline>
      <source src="./video/gift.webm" type="video/webm" />
    </video>
  </div>
</template>

<script setup lang="ts">
import { parseUserAgent } from '@st/utils'

const { browser } = parseUserAgent()
const isSafari = computed(() => browser === 'safari')
</script>

<style scoped>
.animated-gift {
  position: relative;
  width: 100%;
  height: auto;
  background: transparent;
}

.video,
.gif {
  pointer-events: none;

  display: block;

  width: 100%;
  height: auto;

  object-fit: contain;
  background-color: transparent;
}
</style>
